import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { GUIDES, GuideBackNav } from './GuideLayout';
import './Guides.scss';

const TITLE = 'Poradniki - nekrologi, klepsydry, szarfy | Nekrodruk.pl';
const DESCRIPTION =
    'Praktyczne poradniki dla rodzin i zakładów pogrzebowych: jak napisać nekrolog, wzór klepsydry do druku i gotowe napisy na szarfy pogrzebowe.';
const URL = 'https://nekrodruk.pl/poradniki';

// Lista wszystkich poradników - nowe pozycje dodaje się w GUIDES (Guides/GuideLayout.js)
export default function GuidesIndex() {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, []);

    return (
        <main className='guide'>
            <Helmet>
                <title>{TITLE}</title>
                <meta name='description' content={DESCRIPTION} />
                <meta name='robots' content='index, follow' />
                <meta property='og:title' content={TITLE} />
                <meta property='og:description' content={DESCRIPTION} />
                <meta property='og:type' content='website' />
                <meta property='og:url' content={URL} />
                <link rel='canonical' href={URL} />
            </Helmet>

            <section className='guide_hero'>
                <div className='guide_inner'>
                    <nav className='guide_breadcrumbs' aria-label='Ścieżka'>
                        <Link to='/'>Strona główna</Link>
                        <span aria-hidden='true'>/</span>
                        <span aria-current='page'>Poradniki</span>
                    </nav>
                    <span className='guide_kicker guide_kicker--light'>Poradniki</span>
                    <h1 className='guide_heroTitle'>
                        Poradniki<em> dla rodzin i zakładów pogrzebowych</em>
                    </h1>
                    <p className='guide_heroLead'>
                        Praktyczne wskazówki, gotowe wzory i teksty - od treści nekrologu po napisy na szarfy.
                    </p>
                </div>
            </section>

            <div className='guide_body'>
                <section className='guide_section'>
                    <div className='guide_inner'>
                        <div className='guide_index'>
                            {GUIDES.map((guide) => (
                                <Link key={guide.to} to={guide.to} className='guide_relatedCard'>
                                    <span className='guide_kicker'>Poradnik</span>
                                    <strong>{guide.title}</strong>
                                    <span className='guide_text'>{guide.text}</span>
                                    <span className='guide_more'>Czytaj poradnik →</span>
                                </Link>
                            ))}
                        </div>
                    </div>
                </section>

                <GuideBackNav showAllGuides={false} />
            </div>
        </main>
    );
}
